<template>
  <div
    class="shimmer-wrapper bg-gray-200"
    :style="{
      width: width,
      height: height,
      borderRadius: borderRadius
    }"
  ></div>
</template>

<script>
export default {
  name: 'BaseSkeleton',
  props: {
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '1rem',
    },
    borderRadius: {
      type: String,
      default: '0.25rem',
    },
  },
}
</script>
